import './CheckboxMui.scss';
import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Checkbox } from '@mui/material';

const CheckboxMui = ({ label, checked, onChange, disableRipple=false }) => {
  return (

    <FormControlLabel
        control={
          <Checkbox 
            className="custom-checkbox hong-checkbox " 
            disableRipple={disableRipple} 
            checked={!!checked} 
            onChange={onChange} />
        }              
        label={
          <span className='hong-lbl-checkbox'>{label}</span>
        } 
    />
  );
}

export default CheckboxMui;
